module.exports = __webpack_public_path__ + "img/scene2-20.8e2ccf0f.jpg";